import { render, staticRenderFns } from "./AnchorSettingLayout.vue?vue&type=template&id=1fdafd69"
import script from "./AnchorSettingLayout.vue?vue&type=script&lang=js"
export * from "./AnchorSettingLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fdafd69')) {
      api.createRecord('1fdafd69', component.options)
    } else {
      api.reload('1fdafd69', component.options)
    }
    module.hot.accept("./AnchorSettingLayout.vue?vue&type=template&id=1fdafd69", function () {
      api.rerender('1fdafd69', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/settings/layout/AnchorSettingLayout.vue"
export default component.exports